import { Component, EventEmitter, Input, Output } from '@angular/core';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { error } from 'console';
import { finalize, map, Observable } from 'rxjs';
import { ETransportQueryParameters, ETransportResponseDTO } from 'src/app/models/ETransportModel';
import { PackingPlanningService } from 'src/app/services/packing-planning/packing-planning.service';

@Component({
  selector: 'app-milkrun-table',
  templateUrl: './milkrun-table.component.html',
  styleUrl: './milkrun-table.component.css'
})
export class MilkrunTableComponent {
  @Input() toggle: boolean = false;
  @Output() toggleChange = new EventEmitter<boolean>();
  @Output() selectRow = new EventEmitter<any>();
  letUserEdit: boolean = false;
  data$: Observable<ETransportResponseDTO[]> = new Observable();
  data: ETransportResponseDTO[] = [];

  showForm: boolean = false;
  isLoading: boolean = true;

  faCheck = faCheck

  constructor(private packingService: PackingPlanningService) { }

  ngOnInit() {
    this.loadMilkRunTable()
  }

  loadMilkRunTable() {
    const request: ETransportQueryParameters = {
      table: "itemsTimeTableLCB",
      days: 1,
      date_column: "Janela",
      reference_date: this.getCurrentDateFormatted(),
      columns: null
    }

    this.packingService.getEtransportData(request).subscribe({
      next: response => {
        this.data = response.sort((a: any, b: any) => a.Sequencia - b.Sequencia);
        this.isLoading = false
      },
      error: err => {
        console.error(err)
        this.isLoading = false
      }
    });
  }

  getCurrentDateFormatted(): string {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0'); // Janeiro é 0
    const day = String(today.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }


  onSelectRow(data: ETransportResponseDTO, event: MouseEvent) {
    event.stopPropagation();
    this.selectRow.emit(data); //evita a propagação para o overlay do formulário raiz
    this.toggle = !this.toggle
  }

  onToggleClick(event: MouseEvent) {
    event.stopPropagation()
    this.toggleChange.emit(false);
    this.toggle = !this.toggle
  }
}
